import React from 'react';
import { WelcomeStepConfig } from '../../types/WelcomeStepConfig';
import './WelcomeStep.scss';
import t from 'rcm-i18n';

interface Props {
    step: WelcomeStepConfig;
    onContinue: () => void;
}

export const WelcomeStep = (props: Props) => {
    return <div className="certification-training-welcome-page">
        <div>
            <h1>{props.step.middleHeadingText}</h1>
            <div dangerouslySetInnerHTML={{ __html: props.step.bodyHtml }} />
            <button className="btn btn-primary" onClick={props.onContinue}>{t('Continue')}</button>
        </div>
    </div>;
};